import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { HeaderConfigurationToHeader, MARKET_HEADER_EVENTS } from './market-header-events.model';

/**
 * Market → Header configuration producer.
 */
@Service({ autoProvided: false })
export class MarketHeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishHeaderConfiguration(config?: HeaderConfigurationToHeader): void {
		this.eventBus.dispatch(MARKET_HEADER_EVENTS.HEADER_CONFIGURATION, config);
	}

	configureMarketHeader(data: Partial<HeaderConfigurationToHeader> = {}): void {
		this.publishHeaderConfiguration({
			showLogo: true,
			headerRightSectionItems: [{ iconName: 'comment-load', eventId: 'messages', ariaLabel: 'پیام‌ها' }],
			headerLeftSectionItems: [
				{ iconName: 'refresh', eventId: 'refresh', ariaLabel: 'بروزرسانی' },
				{ iconName: 'menu-vertical', eventId: 'menu', ariaLabel: 'تنظیمات ' }
			],
			...data
		});
	}

	resetHeader(): void {
		this.publishHeaderConfiguration();
	}

	clearEventSnapshot(eventId: string): void {
		this.eventBus.clearSnapshot(MARKET_HEADER_EVENTS.HEADER_ACTION, eventId);
	}
}
